import * as React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface FileElementProps {
  files: File[]
}

const FileElements = ({ files }: FileElementProps) => {
  return (
    <>
      {files.map((file, index) => (
        <Box
          key={index}
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
          width="full"
          borderRadius={{ all: 'abs008' }}
          padding="s16"
          flexDirection="row"
          gap="s16"
        >
          <Icon.Medium icon="file-filled" />
          <Text.Normal>{file.name}</Text.Normal>
        </Box>
      ))}
    </>
  )
}

interface AlertProps {
  file: string
}

const AlertMessage = ({ file }: AlertProps) => {
  return (
    <Alert color="warning">
      <Box flexDirection="row" gap="s16">
        <Icon.Medium icon="alert-circle" color="grey800" />
        <Text.Normal size="200" weight="medium">
          {i18n.t('bookkeepers.clients.payroll_periods.missing_file', { file })}
        </Text.Normal>
      </Box>
    </Alert>
  )
}

interface Props {
  payrollResultFiles: File[]
  payrollSummaryFiles: File[]
}

const SummaryComponent = ({ payrollResultFiles, payrollSummaryFiles }: Props) => {
  return (
    <Box gap="s16">
      {payrollResultFiles.length > 0 ? (
        <>
          <Text.Normal size="200" weight="medium">
            {i18n.t('bookkeepers.clients.payroll_periods.payroll_results')}
          </Text.Normal>
          <FileElements files={payrollResultFiles} />
        </>
      ) : (
        <AlertMessage file={i18n.t('bookkeepers.clients.payroll_periods.payroll_results')} />
      )}
      {payrollSummaryFiles.length > 0 ? (
        <>
          <Text.Normal size="200" weight="medium">
            {i18n.t('bookkeepers.clients.payroll_periods.payroll_summary')}
          </Text.Normal>
          <FileElements files={payrollSummaryFiles} />
        </>
      ) : (
        <AlertMessage file={i18n.t('bookkeepers.clients.payroll_periods.payroll_summary')} />
      )}
    </Box>
  )
}

export default SummaryComponent
